exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  background: #f5f4f3;\n}\n.BirdhouseContainer div.BirdhouseComponent {\n  margin-top: 64px;\n}\n@media (max-width: 767px) {\n  .BirdhouseContainer div.BirdhouseComponent {\n    margin-top: 0;\n  }\n}\n.body-bg-color--vrbo {\n  background-color: #f9f8f7;\n}\n", ""]);

// exports
